import React, { Component } from "react";
import "./skillhtml.css";
import $ from "jquery";
import Previews from "./addImage";
import TextWithImage from "./TextWithImage";
import Text from "./Text";
import SliderWithImages from "./SliderWithImages";
import AddYourContent from "./AddYourContent";
import { Editor } from "react-draft-wysiwyg";
import "../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Editors from "./Editors";
import AddComponent from "./AddComponent";

export default class CoursePreview extends Component {
  state = { text: "Hello World" };

  onSaveData = (data, elementId) => {
    this.props.onSaveData(data, elementId)
  };

  render() {
    return (
      <React.Fragment>
        {this.props.currentPage.elements.map(element =>
          element.type == 1 && element.exist ? (
            <TextWithImage
              element={element}
              editMode={this.props.editMode}
              currentPage={this.props.currentPage}
              onSaveData={this.onSaveData}
            />
          ) : element.type == 2 && element.exist ? (
            <Text
              element={element}
              editMode={this.props.editMode}
              currentPage={this.props.currentPage}
              onSaveData={this.onSaveData}
            />
          ) : element.type == 3 && element.exist ? (
            <SliderWithImages
              element={element}
              editMode={this.props.editMode}
              currentPage={this.props.currentPage}
              onSaveData={this.onSaveData}
            />
          ) : element.type == 4 && element.exist ? (
            <AddComponent
              element={element}
              editMode={this.props.editMode}
              currentPage={this.props.currentPage}
              onSaveData={this.onSaveData}
            />
          ) : (
            ""
          )
        )}

        {/* <footer class="footer mt-auto py-3 bg-dark  h-auto">
          <div class="container">
            <span class="text-light">Copyright @ 2019 </span>
          </div>
        </footer>
        <div class="export-div bg-secondary py-3">
          <div class="container">
            <div class="ml-auto text-light">
              <span class="disable-editing">
                If you want to export HTML then you have to disable editing.
              </span>
              <span class="enable-editing d-none">
                Once you export HTML you won't be able to edit again.
              </span>
              <span class="btn btn-sm btn-success export-html mx-1 d-none">
                Export HTML
              </span>
            </div>
          </div>
        </div> */}
      </React.Fragment>
    );
  }
}
